
import { api } from '../core';
import { ServiceDefinition } from '../../types';
import { MOCK_SERVICES } from '../mockData';

const mapToUI = (apiSvc: any): ServiceDefinition => {
    let config: any = {};
    try { config = JSON.parse(apiSvc.config || '{}'); } catch(e) {}

    return {
        id: apiSvc.id,
        title: apiSvc.name,
        description: apiSvc.description,
        category: config.category || 'general',
        icon: config.icon || 'fa-cube',
        color: config.color || 'from-slate-500 to-slate-700',
        isPro: config.isPro || false,
        isNew: config.isNew || false,
        integrations: config.integrations || [],
        capabilities: config.capabilities || []
    };
};

export const ServicesService = {
  getAll: async (): Promise<ServiceDefinition[]> => {
    return api.execute<ServiceDefinition[]>(
      '/api/V1/Service/GetAllByLanguage',
      async () => {
        const saved = localStorage.getItem('lahja_services');
        return saved ? JSON.parse(saved) : MOCK_SERVICES;
      },
      { mockDelay: 300 }
    ).then(res => {
        if (Array.isArray(res) && res.length > 0 && 'endpointUrl' in res[0]) {
            return res.map(mapToUI);
        }
        return res as ServiceDefinition[];
    });
  },
  
  runService: async (serviceId: string, params: any): Promise<any> => {
      // Logic would typically call an endpoint like /api/V1/Service/Run/{id} if it exists
      // For now we simulate it or call the update/custom endpoint
      return api.execute(
          `/api/V1/Service/Update/${serviceId}`, // Placeholder until "Run" endpoint exists
          { success: true, message: 'Service executed locally (simulated)' },
          { method: 'PUT', body: { id: serviceId, body: { ...params } } }
      );
  }
};
